
<div class="dashboard-group">
  <div>
    <h3 class="title-header">Dashboard<sup><i *ngIf="!isNewWindow" class="fa fa-window-restore open-window" (click)="openWindow()"></i></sup></h3>
  </div>
  <app-candle-chart></app-candle-chart>
</div>